<script>
import { RECEIPT_QUERY } from '@/graph/gql/orders.gql'

export default {
  name: 'ReceiptView',
  props: {
    preloaded: { type: Object, default: null }
  },
  apollo: {
    order: {
      query: RECEIPT_QUERY,
      variables() {
        return { id: this.$route.params.id }
      }
    }
  },
  computed: {
    containerFeeSummary() {
      const reducer = (acc, cur) =>
        acc + cur.product.containerFee * cur.quantity

      return this.order.lineItems.reduce(reducer, 0)
    }
  },
  created() {
    if (this.preloaded && this.preloaded.order) {
      this.order = this.preloaded.order
    }
  },
  methods: {
    // Go back
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<template>
  <div>
    <!-- Toolbar -->
    <v-app-bar color="white" flat app>
      <v-btn icon @click="goBack">
        <v-icon color="black" size="18">$vuetify.icons.arrowBack</v-icon>
      </v-btn>
    </v-app-bar>

    <transition name="slide-up" appear>
      <!-- Receipt view page -->
      <div class="view-grid">
        <div class="content-top">
          <div class="display-1 font-weight-bold mb-3">
            Receipt
          </div>

          <v-skeleton-loader
            :loading="!order"
            transition="fade-transition"
            class="mx-auto"
            type="article"
          >
            <div v-if="order">
              <!-- Receipt title -->
              <div class="receipt-title">
                <h4 class="subtitle-2 font-weight-bold">
                  {{ order.seller.firstName }}
                </h4>
                <span class="caption primary--text">
                  Order #{{ order.id }}
                </span>
              </div>

              <!-- Items list -->
              <v-list class="mt-2">
                <v-list-item v-for="item in order.lineItems" :key="item.id">
                  <span class="flex-grow-1">
                    {{ item.quantity }}× {{ item.product.name }}
                  </span>
                  <div class="secondary--text ml-4">
                    {{ (item.quantity * item.product.price) | round(2, true) }}
                  </div>
                </v-list-item>
              </v-list>

              <v-divider class="my-3" />

              <!-- Fees -->
              <v-list>
                <v-list-item class="body-2">
                  <span class="flex-grow-1"> Delivery fee </span>
                  <div class="secondary--text ml-4">
                    {{ order.deliveryFee || 0 | round(2, true) }}
                  </div>
                </v-list-item>
              </v-list>

              <!-- Total -->
              <div class="d-flex mt-6">
                <h4 class="subtitle-1 font-weight-bold flex-grow-1">
                  TOTAL
                </h4>
                <span class="subtitle-1 font-weight-medium primary--text">
                  <!-- {{ order.currencyCode }}  -->
                  RM {{ order.total }}
                </span>
              </div>
            </div>
          </v-skeleton-loader>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="sass" scoped>
.content-top
  margin-top: 56px

.receipt-title
  line-height: 20px
  h4
    line-height: 16px

.v-list-item
  font-size: 15px
  min-height: 30px
  padding: 0
</style>
